export const Services = {
  PURCHASE_ORDER: {
    path: process.env.REACT_APP_PURCHASE_ORDER,
    method: "",
    descrp: "API TO HANDLE ORDEN COMPRA",
  },
  REPORT: {
    path: process.env.REACT_APP_REPORT,
    method: "",
    descrp: "API TO HANDLE REPORT",
  },
  REPORTS: {
    path: process.env.REACT_APP_MIS_REPORTES,
    method: "",
    descrp: "API TO HANDLE MIS REPORTES",
  },
  ORDEN_SERV: {
    path: process.env.REACT_APP_ORDEN_SERV,
    method: "",
    descrp: "API TO HANDLE ORDEN SERVICIO",
  },
  DOCUMENTS: {
    path: process.env.REACT_APP_DOCUMENTS,
    method: "",
    descrp: "API TO HANDLE DOCUMENTS",
  },
  ADMIN: {
    path: process.env.REACT_APP_ADMIN,
    method: "",
    descrp: "API TO HANDLE ADMIN",
  },
  UPLOADTP: {
    path: process.env.REACT_APP_UPLOADTP,
    method: "",
    descrp: "API TO HANDLE UPLOADTP",
  },
  TRACEABILITY: {
    path: process.env.REACT_APP_TRACEABILITY,
    method: "",
    descrp: "API TO HANDLE TRACEABILITY",
  },
  FINANZAS: {
    path: process.env.REACT_APP_FINANZAS,
    method: "",
    descrp: "API TO HANDLE FINANZAS",
  },
  MAIL: {
    path: process.env.REACT_APP_MAIL,
    method: "",
    descrp: "API TO HANDLE MAIL",
  },
  DASHBOARD: {
    path: process.env.REACT_APP_DASHBOARD,
    method: "",
    descrp: "API DASHBOARD",
  },
  AUDIT: {
    path: process.env.REACT_APP_AUDIT,
    method: "",
    descrp: "API TO HANDLE AUDIT",
  },
  PLANTRANSPORT: {
    path: process.env.REACT_APP_PLANTRANSPORT,
    method: "",
    descrp: "API TO HANDLE PLANTRANSPORT",
  },
  Dowload_Excel: {
    path: process.env.REACT_APP_REPORT,
    method: "GET",
    descrp: "METHOD TO GET EXCELL",
  },
  CLARITY: {
    path: process.env.REACT_APP_CLARITY,
    descrp: "CODE CLARITY",
  },
  PROCESS_JOBS: {
    path: process.env.REACT_APP_PROCESS_JOBS,
    descrp: "PROCESS JOBS",
  },
};
